import axios from 'axios'
import { getAccessToken } from 'utils/Storages'

const apiHost = process.env.REACT_APP_SERVER_API_BASE_URL
const API_BASE_URL = apiHost ? `${apiHost}/api` : '/api'

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  config => {
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default apiClient
